{
  "defaultLanguage": "en",
  "languages": [
    {
      "code": "en",
      "name": "English",
      "requiresGender": false
    },
    {
      "code": "es",
      "name": "Spanish",
      "requiresGender": true
    },
    {
      "code": "es-MX",
      "name": "Spanish(Mexico)",
      "requiresGender": true
    },
    {
      "code": "it",
      "name": "Italian",
      "requiresGender": true
    },
    {
      "code": "de",
      "name": "German",
      "requiresGender": true
    },
    {
      "code": "fr-FR",
      "name": "French(France)",
      "requiresGender": true
    },
    {
      "code": "fr-CA",
      "name": "French(Canada)",
      "requiresGender": true
    },
    {
      "code": "pt-BR",
      "name": "Portuguese(Brazil)",
      "requiresGender": true
    },
    {
      "code": "pt-PT",
      "name": "Portuguese(Portugal)",
      "requiresGender": true
    }
  ]
}
